import React, { createContext } from 'react';
import initialState from './../constants/appContextConstants';

//create context
export const GlobalContext = createContext(initialState);


